<template>
  <div style="height: 100%; width: 100%">
    <div ref="mapContainer" style="height: 100%; width: 100%;"></div>
  </div>
</template>

<script>
import L from 'leaflet';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

// Default marker icons (Vite resolves image imports to URLs; webpack used require()).
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

export default {
  name: "LeafletMap",
  props: {
    address: {
      type: String,
      required: false,
    },
    coordinates: {
      type: String,
      default: null,
    },
    apiKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      map: null,
      marker: null,
      zoom: 17,
      center: null,
      url: `https://api.maptiler.com/maps/streets-v2/256/{z}/{x}/{y}.png?key=${this.apiKey}`,
      attribution:
            '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a>, ' +
            '<a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>',
      iconSize: [25, 41],
    };
  },
  async created() {
    if (!this.coordinates) {
      const response = await fetch(`https://api.maptiler.com/geocoding/${this.address}.json?key=${this.apiKey}`);
      const data = await response.json();
      if (data.features && data.features.length > 0) {
        this.center = L.latLng(data.features[0].center[1], data.features[0].center[0]);
      }
    } else {
      const coordinateArr = this.coordinates.split(" ").join("").split(',');
      this.center = L.latLng(parseFloat(coordinateArr[0]), parseFloat(coordinateArr[1]));
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initMap();
    });
  },
  methods: {
    initMap() {
      if (!this.center || !this.$refs.mapContainer) {
        // Wait for center to be set
        setTimeout(() => this.initMap(), 100);
        return;
      }

      // Initialize the map
      this.map = L.map(this.$refs.mapContainer, {
        zoomSnap: 0.5,
        attributionControl: false,
      }).setView(this.center, this.zoom);

      // Add tile layer
      L.tileLayer(this.url, {
        attribution: this.attribution,
      }).addTo(this.map);

      // Add attribution control
      L.control.attribution({
        position: 'bottomright',
        prefix: false,
      }).addTo(this.map);

      // Add scale control
      L.control.scale({
        imperial: false,
        position: 'bottomleft',
      }).addTo(this.map);

      // Add marker with custom icon
      const customIcon = L.icon({
        iconRetinaUrl: markerIcon2x,
        iconUrl: markerIcon,
        shadowUrl: markerShadow,
        iconSize: this.iconSize,
        iconAnchor: [this.iconSize[0] / 2, this.iconSize[1]],
      });

      this.marker = L.marker(this.center, { icon: customIcon }).addTo(this.map);
    },
  },
  beforeUnmount() {
    if (this.map) {
      this.map.remove();
    }
  },
};
</script>


<style lang="scss">
.leaflet-control-container .leaflet-bottom.leaflet-right {
  div:nth-child(2) {
    display: none;
  }
}
</style>
